import { render } from "./LogoDummy.vue?vue&type=template&id=7f23050b"
import script from "./LogoDummy.vue?vue&type=script&lang=ts"
export * from "./LogoDummy.vue?vue&type=script&lang=ts"
script.render = render

export default script